var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColorCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 112.8 112.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 20.43,
    y1: -582.61,
    x2: 119.07,
    y2: -527.84,
    gradientTransform: "matrix(1, 0, 0, -1, -10.7, -500.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6db759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075be"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.4,
    cy: 56.4,
    r: 56.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.9,96.2s-7.2-7.6-8.1-21.5C25.4,68,28,61,34.8,57.9c10.1-4.6,15.8,6.2,21.5,5,7.8-1.6,4.6-10.8,11.7-21,9.8-14,31-2.8,36.2,12.1C112.5,78.3,98,95.2,98,95.2s-.6-6.6-3.5-11.6c-3.6-6.3-10.1-8.7-15.1-3C71.6,89.4,70.6,96.1,61.3,95,51.8,93.8,40.2,65.8,33.9,96.2Z",
    transform: "translate(-10.7 -12.3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorCircle);
export default __webpack_public_path__ + "static/media/logo-color-circle.38aebf802a0e33774d6b90a74ead239b.svg";
export { ForwardRef as ReactComponent };